<template>
    <div>
        <InputText
                v-model="formModel.firstname"
                inputId="shipping-firstname"
                :inputLbl="lbl.shipping.firstname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[0]"
        ></InputText>
        <InputText
                v-model="formModel.lastname"
                inputId="shipping-lastname"
                :inputLbl="lbl.shipping.lastname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[1]"
        ></InputText>
        <InputContactNumber
                v-model="formModel.contactNumber"
                inputId="shipping-contactnumber"
                delimeter="-"
                :inputLbl="lbl.shipping.contactnumber"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[2]"
        ></InputContactNumber>
        <InputText
                v-model="formModel.address"
                inputId="shipping-address"
                :inputLbl="lbl.shipping.address"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[3]"
        ></InputText>
        <FormAddressDropDown
                formId="shipping-redeem"
                :address="addressModel"
                :lblShipping="lbl.shipping"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :zipcodeError="errorInfo[4]"
                :provinceError="errorInfo[5]"
                :districtError="errorInfo[6]"
                :subDistrictError="errorInfo[7]"
        ></FormAddressDropDown>
        <div class="pt-3 text-center">
            <button class="btn btn-primary" @click="submitAddress()">Save Address</button>
        </div>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";
import FormHelper from "@/helper/FormHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import InputText from "@/components/Input/Text.vue";
import InputContactNumber from "@/components/Input/ContactNumber.vue";
import FormAddressDropDown from "@/components/Form/FormAddressDropdown.vue";
//service
import { AddressModel } from "@/core/Address/model/AddressModel.js"
import { FormAddressModel } from "../model/FormAddressModel.js";

/**
 * @event onSubmitForm
 */
export default {
    name: "FormShippingAddress",
    mixins: [LocaleMixin],
    components: {
        InputText,
        InputContactNumber,
        FormAddressDropDown,
    },
    data: function() {
        return {
            isFirstSave: true,
            errorInfo: [],

            formModel: new FormAddressModel(),
            addressModel: new AddressModel(),
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(8);
    },
    methods: {
        submitAddress: function() {
            this.isFirstSave = false;
            if (this.validateForm()) {
                this.formModel.setValueFromAddressModel(this.addressModel);
                this.$emit('onSubmitForm', this.formModel);
                // Util.log("pass", this.formModel);
            }
        },
        validateForm: function() {
            return FormHelper.validate(this.errorInfo);
        },
    },
}
</script>
<style lang="scss" scoped>
    // @import "@/style/base/base.scss";
</style>
